import {
  GlobeIcon,
  Flex,
  Heading,
  Icon,
  IconButton,
  Link,
} from "@commonsku/design-system";
import React from "react";
import CustomDomainBannerStatusBanner from "./CustomDomainBannerStatusBanner";
import { useSelector } from "react-redux";
import { getCustomDomainEntry } from "../popups/CustomDomainPopups/customDomainEntry";
import { selectCustomDomainData } from "../../../redux/customDomain";

interface CustomDomainBarProps {
  defaultShopUrl: string;
  openPopup: () => void;
}

// Until everything migrated into the new design system and font, we'll be using the current font family within the settings page, modals can use the new font family
const CUSTOM_DOMAIN_BAR_FONT =
  '"museo-sans", "Helvetica Neue", Helvetica, Roboto, Arial, sans-serif';

const CustomDomainBar = ({
  defaultShopUrl,
  openPopup,
}: CustomDomainBarProps) => {
  const customDomain = useSelector(selectCustomDomainData);
  const isActive = customDomain?.isActive ?? false;
  const domainStatus = customDomain?.domainStatus ?? null;
  const customDomainUrl = customDomain?.customDomainUrl ?? null;
  const shopUrl = isActive ? `https://${customDomainUrl}` : defaultShopUrl;
  const shopUrlText = isActive
    ? `https://${customDomainUrl}`
    : `https://${window.location.hostname}${defaultShopUrl}`;
  const currentDomainEntry = getCustomDomainEntry(isActive, domainStatus);
  return (
    <>
      <Flex
        justify="space-between"
        fontFamily={CUSTOM_DOMAIN_BAR_FONT}
        css={{
          "& button, & a, & p, & h4, & span": {
            fontFamily: CUSTOM_DOMAIN_BAR_FONT,
          },
        }}
      >
        <Flex direction="column" justify="space-between">
          <Heading as="h4" marginBottom={0}>
            General
          </Heading>
          <Link
            target="_blank"
            variant="plain"
            href={shopUrl}
            rel="noopener noreferrer"
            colorPalette="brand"
          >
            {shopUrlText}
          </Link>
        </Flex>
        {!isActive && domainStatus === null ? (
          <IconButton
            colorPalette="brand"
            onClick={openPopup}
            size="md"
            variant="ghost"
            marginRight={7}
            label="custom domain globe icon button"
            fontWeight="semibold"
            data-testid="customDomain-bar-connect.btn"
            p={2}
          >
            <Icon ariaLabel="custom domain globe icon" color="brand" size="md">
              <GlobeIcon />
            </Icon>
            Connect Custom Domain
          </IconButton>
        ) : (
          <CustomDomainBannerStatusBanner
            currentDomainEntry={currentDomainEntry}
            openPopup={openPopup}
          />
        )}
      </Flex>
    </>
  );
};

export default CustomDomainBar;
